module.exports = __webpack_public_path__ + "static/media/cropping_01.de67bada.png";